import React from "react";
import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import { getPermisosPorCategoria } from "../../../../resources/Helper";
import Unauthorized from "../../general/Unauthorized";
import CustomSwitch from "../../custom/CustomSwitch";

function EditarRol() {

    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState({});
    const [permissions, setPermissions] = useState([]);

    const [permisosPacientes, setPermisosPacientes] = useState([]);
    const [permisosInventario, setPermisosInventario] = useState([]);
    const [permisosFacturacion, setPermisosFacturacion] = useState([]);
    const [permisosContabilidad, setPermisosContabilidad] = useState([]);
    const [permisosGenerales, setPermisosGenerales] = useState([]);
    const [permisosAgenda, setPermisosAgenda] = useState([]);
    const [permisosAdministracion, setPermisosAdministracion] = useState([]);
    const [permisosTipoUsuario, setPermisosTipoUsuario] = useState([]);
    const [permisosPersonal, setPermisosPersonal] = useState([]);
    const [permisosReportes, setPermisosReportes] = useState([]);
    const [permisosIndicadores, setPermisosIndicadores] = useState([]);
    const [permisosConfiguracion, setPermisosConfiguracion] = useState([]);
    const [permisosLaboratorio, setPermisosLaboratorio] = useState([]);
    
    const [roleName, setRoleName] = useState('');
    const [roleDescription, setRoleDescription] = useState('');

    let history = useHistory();

    let userdata = [];
    const [rolep, setRolep] = useState([]);

    const addPermission = (permissionId) => {
        setRolep(prevPermissions => {
            let newPermissions = [...prevPermissions];
            let permissionIndex = newPermissions.indexOf(permissionId);
            
            if (permissionIndex > -1) {
                newPermissions.splice(permissionIndex, 1);
            } else {
                newPermissions.push(permissionId);
            }

            console.log('Updated permissions:', newPermissions);
            return newPermissions;
        });
    }

    // 🔄 Función para marcar/desmarcar todos los permisos de una sección
    const toggleAllPermissions = (sectionPermissions, sectionName) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        const allSelected = sectionIds.every(id => rolep.includes(id));
        
        setRolep(prevPermissions => {
            let newPermissions = [...prevPermissions];
            
            if (allSelected) {
                // Desmarcar todos los de esta sección
                newPermissions = newPermissions.filter(id => !sectionIds.includes(id));
            } else {
                // Marcar todos los de esta sección
                sectionIds.forEach(id => {
                    if (!newPermissions.includes(id)) {
                        newPermissions.push(id);
                    }
                });
            }
            
            return newPermissions;
        });
    };

    // 🔍 Función para verificar si todos los permisos de una sección están seleccionados
    const areAllSectionPermissionsSelected = (sectionPermissions) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        return sectionIds.length > 0 && sectionIds.every(id => rolep.includes(id));
    };

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a editar roles
        const tienePermiso = userdata.up && userdata.up.includes('administrarSeguridad');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    //console.log(response.data);
                    //console.log(JSON.stringify(client));

                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
        

        /*axios.get('/permissions', config)
            .then(response => {
                if (response.status===200) {
                    setPermissions(response.data);
                    console.log(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
        */
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/role',config2)
            .then(response => {
                setRoleName(response.data.name);
                setRoleDescription(response.data.description);
                setPermissions(response.data.permissions);

                //////////////////////////////

                setPermisosPacientes(getPermisosPorCategoria(response.data.permissions,'pacientes'));
                setPermisosInventario(getPermisosPorCategoria(response.data.permissions,'inventario'));
                setPermisosGenerales(getPermisosPorCategoria(response.data.permissions,'general'));
                setPermisosFacturacion(getPermisosPorCategoria(response.data.permissions,'facturacion'));
                setPermisosContabilidad(getPermisosPorCategoria(response.data.permissions,'contabilidad'));
                setPermisosAgenda(getPermisosPorCategoria(response.data.permissions,'agenda'));
                setPermisosAdministracion(getPermisosPorCategoria(response.data.permissions,'administracion'));
                setPermisosTipoUsuario(getPermisosPorCategoria(response.data.permissions,'tipo_usuario'));
                setPermisosPersonal(getPermisosPorCategoria(response.data.permissions,'personal'));
                setPermisosReportes(getPermisosPorCategoria(response.data.permissions,'reportes'));
                setPermisosIndicadores(getPermisosPorCategoria(response.data.permissions,'indicadores'));
                setPermisosConfiguracion(getPermisosPorCategoria(response.data.permissions,'configuracion'));
                setPermisosLaboratorio(getPermisosPorCategoria(response.data.permissions,'laboratorio'));

                //////////////////////////////
                
                let initialPermissions = [];
                for (let k=0;k<response.data.permissions.length;k++) {
                    let perm = response.data.permissions[k];
                    
                    if (perm.permission_id!=null) {
                        initialPermissions.push(perm.id);
                    }
                }

                setRolep(initialPermissions);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            id: id,
            client_id: client.client_id,
            name: roleName,
            description: roleDescription,
            permissions: JSON.stringify(rolep)
        };
        
        console.log(conf);

        axios.put('/role', conf)
            .then(
                response => {
                    setLoading(false);

                    history.push('/roles');
                }
            )
            .catch(
                err => {
                    setLoading(false);
                }
            )
    }

    function mapPermisos(permisoNombre, permisoId, perm) {
        return (
            <div key={permisoId} className="permission-item d-flex justify-content-between align-items-center py-2 px-3 mb-2 border rounded">
                <label className="mb-0 permission-label" style={{fontSize: '0.9rem', fontWeight: '500'}}>
                    {permisoNombre}
                </label>
                <CustomSwitch
                    checked={rolep.includes(permisoId)}
                    onChange={() => addPermission(permisoId)}
                />
            </div>
        );
    }


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <style>{`
                    .permission-group {
                        background: #f8f9fa;
                        border-radius: 8px;
                        padding: 20px;
                        margin-bottom: 25px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    }
                    
                    .permission-item {
                        background: white;
                        transition: all 0.2s ease;
                        cursor: pointer;
                        min-height: 45px;
                    }
                    
                    .permission-item:hover {
                        background: #e3f2fd;
                        border-color: #2196f3 !important;
                    }
                    
                    .permission-label {
                        color: #495057;
                        cursor: pointer;
                    }
                    
                    .card-body::-webkit-scrollbar {
                        width: 8px;
                    }
                    
                    .card-body::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 4px;
                    }
                    
                    .card-body::-webkit-scrollbar-thumb {
                        background: #c1c1c1;
                        border-radius: 4px;
                    }
                    
                    .card-body::-webkit-scrollbar-thumb:hover {
                        background: #a8a8a8;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/security">Seguridad y Permisos</Link></li>
                                        <li className="breadcrumb-item" key="bc5"><Link to="/roles">Roles de usuario</Link></li>
                                        <li className="breadcrumb-item" key="bc6">Editar Rol</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Rol</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleName">Nombre</label>
                                                                <input type="text" name="name" className="form-control" id="roleName" value={roleName} onChange={(e) => setRoleName(e.target.value)} required disabled={loading} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleDescription">Descripción</label>
                                                                <input type="text" name="description" className="form-control" id="roleDescription" value={roleDescription} onChange={(e) => setRoleDescription(e.target.value)} disabled={loading} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">
                                                    <i className="fas fa-shield-alt"></i> Configuración de Permisos
                                                </h3>
                                            </div>
                                            <div className="card-body" style={{maxHeight: '70vh', overflowY: 'auto', minHeight: '500px'}}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        {/* Permisos Generales */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-primary mb-0">
                                                                    <i className="fas fa-cog mr-2"></i>Permisos Generales
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllGenerales"
                                                                        checked={areAllSectionPermissionsSelected(permisosGenerales)}
                                                                        onChange={() => toggleAllPermissions(permisosGenerales, 'Generales')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllGenerales">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosGenerales.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Administración */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-danger mb-0">
                                                                    <i className="fas fa-users-cog mr-2"></i>Permisos de Administración
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllAdministracion"
                                                                        checked={areAllSectionPermissionsSelected(permisosAdministracion)}
                                                                        onChange={() => toggleAllPermissions(permisosAdministracion, 'Administración')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllAdministracion">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosAdministracion.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                            <div className="alert alert-warning mt-2 mb-0" style={{fontSize: '0.85rem'}}>
                                                                <i className="fas fa-exclamation-triangle mr-1"></i>
                                                                <strong>Nota:</strong> Los permisos de administración otorgan acceso a funciones críticas del sistema.
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Agenda */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-info mb-0">
                                                                    <i className="fas fa-calendar-alt mr-2"></i>Permisos de Agenda
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllAgenda"
                                                                        checked={areAllSectionPermissionsSelected(permisosAgenda)}
                                                                        onChange={() => toggleAllPermissions(permisosAgenda, 'Agenda')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllAgenda">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosAgenda.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Inventario */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-secondary mb-0">
                                                                    <i className="fas fa-boxes mr-2"></i>Permisos de Inventario
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllInventario"
                                                                        checked={areAllSectionPermissionsSelected(permisosInventario)}
                                                                        onChange={() => toggleAllPermissions(permisosInventario, 'Inventario')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllInventario">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosInventario.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Personal */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-orange mb-0" style={{color: '#fd7e14'}}>
                                                                    <i className="fas fa-users mr-2"></i>Permisos de Personal
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllPersonal"
                                                                        checked={areAllSectionPermissionsSelected(permisosPersonal)}
                                                                        onChange={() => toggleAllPermissions(permisosPersonal, 'Personal')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllPersonal">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosPersonal.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Reportes */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-teal mb-0" style={{color: '#20c997'}}>
                                                                    <i className="fas fa-chart-bar mr-2"></i>Permisos de Reportes
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllReportes"
                                                                        checked={areAllSectionPermissionsSelected(permisosReportes)}
                                                                        onChange={() => toggleAllPermissions(permisosReportes, 'Reportes')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllReportes">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosReportes.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        {/* Permisos de Pacientes */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-success mb-0">
                                                                    <i className="fas fa-user-injured mr-2"></i>Permisos de Pacientes
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllPacientes"
                                                                        checked={areAllSectionPermissionsSelected(permisosPacientes)}
                                                                        onChange={() => toggleAllPermissions(permisosPacientes, 'Pacientes')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllPacientes">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosPacientes.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Facturación */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-warning mb-0">
                                                                    <i className="fas fa-file-invoice-dollar mr-2"></i>Permisos de Facturación
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllFacturacion"
                                                                        checked={areAllSectionPermissionsSelected(permisosFacturacion)}
                                                                        onChange={() => toggleAllPermissions(permisosFacturacion, 'Facturación')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllFacturacion">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosFacturacion.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Contabilidad */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-dark mb-0">
                                                                    <i className="fas fa-calculator mr-2"></i>Permisos de Contabilidad
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllContabilidad"
                                                                        checked={areAllSectionPermissionsSelected(permisosContabilidad)}
                                                                        onChange={() => toggleAllPermissions(permisosContabilidad, 'Contabilidad')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllContabilidad">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosContabilidad.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Tipo de Usuario */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-purple mb-0" style={{color: '#6f42c1'}}>
                                                                    <i className="fas fa-user-tag mr-2"></i>Tipo de Usuario
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllTipoUsuario"
                                                                        checked={areAllSectionPermissionsSelected(permisosTipoUsuario)}
                                                                        onChange={() => toggleAllPermissions(permisosTipoUsuario, 'Tipo de Usuario')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllTipoUsuario">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosTipoUsuario.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Indicadores */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-purple mb-0" style={{color: '#6f42c1'}}>
                                                                    <i className="fas fa-chart-line mr-2"></i>Permisos de Indicadores
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllIndicadores"
                                                                        checked={areAllSectionPermissionsSelected(permisosIndicadores)}
                                                                        onChange={() => toggleAllPermissions(permisosIndicadores, 'Indicadores')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllIndicadores">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosIndicadores.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Configuración */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-dark mb-0">
                                                                    <i className="fas fa-sliders-h mr-2"></i>Permisos de Configuración
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllConfiguracion"
                                                                        checked={areAllSectionPermissionsSelected(permisosConfiguracion)}
                                                                        onChange={() => toggleAllPermissions(permisosConfiguracion, 'Configuración')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllConfiguracion">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosConfiguracion.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>

                                                        {/* Permisos de Laboratorio */}
                                                        <div className="permission-group mb-4">
                                                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                                <h5 className="text-success mb-0" style={{color: '#28a745'}}>
                                                                    <i className="fas fa-flask mr-2"></i>Permisos de Laboratorio
                                                                </h5>
                                                                <div className="form-check">
                                                                    <input 
                                                                        className="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="selectAllLaboratorio"
                                                                        checked={areAllSectionPermissionsSelected(permisosLaboratorio)}
                                                                        onChange={() => toggleAllPermissions(permisosLaboratorio, 'Laboratorio')}
                                                                    />
                                                                    <label className="form-check-label text-muted" htmlFor="selectAllLaboratorio">
                                                                        <small>Marcar todos</small>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="permission-list">
                                                                {permisosLaboratorio.map((permission) => mapPermisos(permission.name, permission.id, permission.permission_id))}
                                                            </div>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    

                                        <div className="d-flex gap-2" style={{margin: '30px 0 30px 8px'}}>
                                            <Link to="/roles" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Guardar cambios&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            </button>
                                        </div>
                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarRol;